class OrderSettings {

    constructor({
                    minimumQuantity = 1,
                    intervalDeliveryTime = 10,
                    intervalTakeAwayTime = 10,
                    preparationTime = 30,
                    rangeScheduleTime = 20,
                    deliveryTime = 30,
                    deliveryTimeLongDistance = 50,
                    extendedBarTime = 120,
                    allowCouponPaymentMethodDiscount = false,
                    couponPaymentMethodDiscountPriority = 'Aplicar el mayor descuento'
                }) {
        this.className = "OrderSettings"

        this.minimumQuantity = minimumQuantity
        this.intervalDeliveryTime = intervalDeliveryTime
        this.intervalTakeAwayTime = intervalTakeAwayTime
        this.preparationTime = preparationTime
        this.rangeScheduleTime = rangeScheduleTime
        this.deliveryTime = deliveryTime
        this.deliveryTimeLongDistance = deliveryTimeLongDistance
        this.extendedBarTime = extendedBarTime
        this.allowCouponPaymentMethodDiscount = allowCouponPaymentMethodDiscount
        this.couponPaymentMethodDiscountPriority = couponPaymentMethodDiscountPriority
    }
}


export default OrderSettings;
